/**
 * @module modules/triage-panel-sk
 * @description <h2><code>triage-panel-sk</code></h2>
 *
 * Triage Panel provides a staging area for performance sheriffs to create arbitrary custom buckets,
 * place anomalies into them, and perform mass triage actions.
 * It delegates individual bucket rendering and smart state machine handling (NEW -> APPLIED -> DIRTY)
 * to the child triage-bucket-sk component.
 * It features a drag-to-move header and a minimize/collapse toggle to prevent toolbar overlap.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TriageBucket: function() {
        return _bucketscontroller.TriageBucket;
    },
    TriagePanelSk: function() {
        return TriagePanelSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _repeat = require("lit/directives/repeat.js");
const _bucketscontroller = require("./buckets-controller");
require("./triage-bucket-sk");
require("../../../elements-sk/modules/icons/add-icon-sk");
require("../../../elements-sk/modules/icons/content-copy-icon-sk");
require("../../../elements-sk/modules/icons/content-paste-icon-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let TriagePanelSk = class TriagePanelSk extends _lit.LitElement {
    get buckets() {
        return this.bucketsController.buckets;
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('bucket-updated', this.onBucketUpdated);
        this.addEventListener('bucket-deleted', this.onBucketDeleted);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('bucket-updated', this.onBucketUpdated);
        this.removeEventListener('bucket-deleted', this.onBucketDeleted);
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
    }
    onResizeMouseDown(e, dir) {
        e.stopPropagation();
        e.preventDefault();
        this.isResizing = true;
        this.resizeDir = dir;
        this.startX = e.clientX;
        this.startY = e.clientY;
        const rect = this.getBoundingClientRect();
        this.startWidth = rect.width;
        this.startHeight = rect.height;
        this.startLeft = rect.left;
        this.startTop = rect.top;
        document.addEventListener('mousemove', this.onResizeMouseMove);
        document.addEventListener('mouseup', this.onResizeMouseUp);
    }
    render() {
        return (0, _lit.html)`
      <div
        class="resize-handle n"
        @mousedown=${(e)=>this.onResizeMouseDown(e, 'n')}></div>
      <div
        class="resize-handle s"
        @mousedown=${(e)=>this.onResizeMouseDown(e, 's')}></div>
      <div
        class="resize-handle e"
        @mousedown=${(e)=>this.onResizeMouseDown(e, 'e')}></div>
      <div
        class="resize-handle w"
        @mousedown=${(e)=>this.onResizeMouseDown(e, 'w')}></div>
      <div
        class="resize-handle ne"
        @mousedown=${(e)=>this.onResizeMouseDown(e, 'ne')}></div>
      <div
        class="resize-handle nw"
        @mousedown=${(e)=>this.onResizeMouseDown(e, 'nw')}></div>
      <div
        class="resize-handle se"
        @mousedown=${(e)=>this.onResizeMouseDown(e, 'se')}></div>
      <div
        class="resize-handle sw"
        @mousedown=${(e)=>this.onResizeMouseDown(e, 'sw')}></div>

      <div class="header" @mousedown=${this.onMouseDown}>
        <span>Triage Panel</span>
        <button
          class="collapse-btn"
          @click=${(e)=>{
            e.stopPropagation();
            this.collapsed = !this.collapsed;
            if (this.collapsed) {
                this.style.height = 'auto';
            }
        }}
          title=${this.collapsed ? 'Expand panel' : 'Collapse panel'}>
          ${this.collapsed ? '[+]' : '[-]'}
        </button>
      </div>

      <div class="panel-content" ?hidden=${this.collapsed}>
        <div class="add-bucket">
          <input
            type="text"
            placeholder="Add new bucket..."
            .value=${this.newBucketName}
            @input=${(e)=>this.newBucketName = e.target.value}
            @keydown=${this.onNewBucketKeyDown} />
          <button class="icon-btn" title="Add Bucket" @click=${this.addNewBucket}>
            <add-icon-sk></add-icon-sk>
          </button>
          <button
            class="icon-btn"
            title="Copy all panel buckets to clipboard"
            @click=${this.onCopyAll}>
            <content-copy-icon-sk></content-copy-icon-sk>
          </button>
          <button
            class="icon-btn"
            title="Paste panel state from clipboard"
            @click=${this.onPasteAll}>
            <content-paste-icon-sk></content-paste-icon-sk>
          </button>
        </div>

        <div class="buckets-grid">
          ${(0, _repeat.repeat)(this.buckets, (b)=>b.name, (bucket)=>(0, _lit.html)`
              <triage-bucket-sk
                .bucket=${bucket}
                .anomalies=${this.anomalies}
                .traceNames=${this.traceNames}>
              </triage-bucket-sk>
            `)}
        </div>
      </div>
    `;
    }
    onNewBucketKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.addNewBucket();
        }
    }
    addNewBucket() {
        if (this.bucketsController.addNewBucket(this.newBucketName)) {
            this.newBucketName = '';
        }
    }
    onBucketUpdated(e) {
        this.bucketsController.updateBucket(e.detail.bucket);
    }
    onBucketDeleted(e) {
        this.bucketsController.deleteBucket(e.detail.name);
    }
    addToBucket(name, anomaliesToAdd) {
        this.bucketsController.addToBucket(name, anomaliesToAdd);
    }
    getStagedAnomalyIds() {
        return this.bucketsController.getStagedAnomalyIds();
    }
    onCopyAll() {
        this.bucketsController.copyAll();
    }
    onPasteAll() {
        this.bucketsController.pasteAll(this.anomalies);
    }
    constructor(...args){
        super(...args);
        this.anomalies = [];
        this.traceNames = [];
        this.newBucketName = '';
        this.collapsed = false;
        this.bucketsController = new _bucketscontroller.TriageBucketsController(this);
        this.isDragging = false;
        this.xOffset = 0;
        this.yOffset = 0;
        this.isResizing = false;
        this.resizeDir = '';
        this.startX = 0;
        this.startY = 0;
        this.startWidth = 0;
        this.startHeight = 0;
        this.startLeft = 0;
        this.startTop = 0;
        this.onMouseDown = (e)=>{
            const header = this.querySelector('.header');
            if (!header || !header.contains(e.target)) {
                return;
            }
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
            this.isDragging = true;
            const rect = this.getBoundingClientRect();
            this.xOffset = e.clientX - rect.left;
            this.yOffset = e.clientY - rect.top;
        };
        this.onMouseMove = (e)=>{
            if (!this.isDragging) return;
            e.preventDefault();
            const newLeft = e.clientX - this.xOffset;
            const newTop = e.clientY - this.yOffset;
            const maxLeft = window.innerWidth - this.offsetWidth;
            const maxTop = window.innerHeight - this.offsetHeight;
            this.style.left = `${Math.max(0, Math.min(newLeft, maxLeft))}px`;
            this.style.top = `${Math.max(0, Math.min(newTop, maxTop))}px`;
            this.style.right = 'auto';
        };
        this.onMouseUp = (e)=>{
            if (this.isDragging) {
                e.preventDefault();
                this.isDragging = false;
                document.removeEventListener('mousemove', this.onMouseMove);
                document.removeEventListener('mouseup', this.onMouseUp);
            }
        };
        this.onResizeMouseMove = (e)=>{
            if (!this.isResizing) return;
            e.preventDefault();
            const dx = e.clientX - this.startX;
            const dy = e.clientY - this.startY;
            const minWidth = 350;
            const minHeight = 150;
            let newWidth = this.startWidth;
            let newHeight = this.startHeight;
            let newLeft = this.startLeft;
            let newTop = this.startTop;
            if (this.resizeDir.includes('e')) {
                newWidth = Math.max(minWidth, this.startWidth + dx);
            }
            if (this.resizeDir.includes('w')) {
                const possibleWidth = this.startWidth - dx;
                if (possibleWidth >= minWidth) {
                    newWidth = possibleWidth;
                    newLeft = this.startLeft + dx;
                } else {
                    newWidth = minWidth;
                    newLeft = this.startLeft + (this.startWidth - minWidth);
                }
            }
            if (this.resizeDir.includes('s')) {
                newHeight = Math.max(minHeight, this.startHeight + dy);
            }
            if (this.resizeDir.includes('n')) {
                const possibleHeight = this.startHeight - dy;
                if (possibleHeight >= minHeight) {
                    newHeight = possibleHeight;
                    newTop = this.startTop + dy;
                } else {
                    newHeight = minHeight;
                    newTop = this.startTop + (this.startHeight - minHeight);
                }
            }
            this.style.width = `${newWidth}px`;
            this.style.height = `${newHeight}px`;
            this.style.left = `${newLeft}px`;
            this.style.top = `${newTop}px`;
            this.style.right = 'auto';
            this.style.bottom = 'auto';
        };
        this.onResizeMouseUp = (e)=>{
            if (this.isResizing) {
                e.preventDefault();
                this.isResizing = false;
                document.removeEventListener('mousemove', this.onResizeMouseMove);
                document.removeEventListener('mouseup', this.onResizeMouseUp);
            }
        };
    }
};
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Array)
], TriagePanelSk.prototype, "anomalies", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Array)
], TriagePanelSk.prototype, "traceNames", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], TriagePanelSk.prototype, "newBucketName", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean,
        reflect: true
    }),
    _ts_metadata("design:type", Boolean)
], TriagePanelSk.prototype, "collapsed", void 0);
TriagePanelSk = _ts_decorate([
    (0, _decorators.customElement)('triage-panel-sk')
], TriagePanelSk);
